import moment from 'moment';

function SettingsVenueScheduleInventoryCtrl($scope, $state, $stateParams, $q) { //eslint-disable-line
  const vm = this;

  vm.loading = true;
  vm.venueId = $stateParams.venueId;
  vm.currentDay = {
    number: (new Date()).getDay()
  };

  vm.days = [{
    name: 'Sunday',
    number: 0
  }, {
    name: 'Monday',
    number: 1
  }, {
    name: 'Tuesday',
    number: 2
  }, {
    name: 'Wednesday',
    number: 3
  }, {
    name: 'Thursday',
    number: 4
  }, {
    name: 'Friday',
    number: 5
  }, {
    name: 'Saturday',
    number: 6
  }];

  vm.currentDateUTC = $stateParams.date ? moment.utc(parseInt($stateParams.date, 10)) : moment();

  vm.loading = true;

  vm.changeCurrentDay = _changeCurrentDay;

  vm.showWrkflowsArticle = function($event) {
    if ($event) $event.preventDefault();

    window.wrkflows.showArticle('1067');
  };

  $q.all([
      $scope.venuePromise
    ])
    .then(results => {
      vm.venue = results[0];
    })
    .finally(() => {
      vm.loading = false;
    });

  function _changeCurrentDay(day = 0, $event = null) {
    if ($event) $event.preventDefault();

    vm.currentDay = {
      number: day
    };
  }
}

SettingsVenueScheduleInventoryCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q'
];

export default SettingsVenueScheduleInventoryCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsVenueScheduleInventory/settingsVenueScheduleInventoryCtrl.js